// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__8SvO5","logoCollapsed":"logo_logoCollapsed__9yUWQ"};